import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { MultipleChoiceEdit } from './edit.component';
import { MultipleChoicePreview } from './preview.component';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MultipleChoiceEditLayout = styled.div.withConfig({
  displayName: "multiple-choice__MultipleChoiceEditLayout",
  componentId: "sc-hvnw22-0"
})(["display:", ";"], function (props) {
  return props.isFocus ? 'block' : 'none';
});
var MultipleChoicePreviewLayout = styled.div.withConfig({
  displayName: "multiple-choice__MultipleChoicePreviewLayout",
  componentId: "sc-hvnw22-1"
})(["display:", ";"], function (props) {
  return props.isFocus ? 'none' : 'block';
});
export var MultipleChoice = function MultipleChoice(props) {
  var _useState = useState(false),
      isFocus = _useState[0],
      setIsFocus = _useState[1];

  var question = props.question,
      index = props.index,
      isDisabledInputs = props.isDisabledInputs,
      deleteAnswerStatus = props.deleteAnswerStatus,
      createAnswerStatus = props.createAnswerStatus,
      onDelete = props.onDelete,
      onUpdateCorrectAnswer = props.onUpdateCorrectAnswer,
      onUpdate = props.onUpdate,
      onUpdateType = props.onUpdateType,
      onCreateAnswer = props.onCreateAnswer,
      onResetCreateAnswer = props.onResetCreateAnswer,
      onUpdateAnswer = props.onUpdateAnswer,
      onDeleteAnswer = props.onDeleteAnswer,
      onResetDeleteAnswer = props.onResetDeleteAnswer,
      onFocusQuestion = props.onFocusQuestion,
      editingQuestionId = props.editingQuestionId,
      defaultDescription = props.defaultDescription;

  var useClickOutside = function useClickOutside(ref) {
    useEffect(function () {
      function handleClickAnotherPreviewComponent(event) {
        event.stopPropagation();
        var questionPreviewElements = document.querySelectorAll('[data-question-preview]');
        questionPreviewElements.forEach(function (previewElement) {
          if (previewElement === wrapperPreviewRef.current) return;

          if (previewElement.contains(event.target)) {
            setIsFocus(false);
            return;
          }
        });
      }

      document.addEventListener('mousedown', handleClickAnotherPreviewComponent);
      return function () {
        document.removeEventListener('mousedown', handleClickAnotherPreviewComponent);
      };
    }, [ref]);
  };

  var useClickInside = function useClickInside(ref) {
    useEffect(function () {
      function handleClickInside(event) {
        if (ref.current && ref.current.contains(event.target)) {
          setIsFocus(true);
        }
      }

      document.addEventListener('mousedown', handleClickInside);
      return function () {
        document.removeEventListener('mousedown', handleClickInside);
      };
    }, [ref]);
  };

  var wrapperEditRef = useRef(null);
  useClickOutside(wrapperEditRef);
  var wrapperPreviewRef = useRef(null);
  useClickInside(wrapperPreviewRef);
  useEffect(function () {
    if (isFocus) {
      onFocusQuestion(index, question);
    }
  }, [isFocus, onFocusQuestion, index, question]);
  useEffect(function () {
    if (editingQuestionId === question.id.toString()) {
      setIsFocus(true);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/_jsxs("div", {
    id: question.id.toString(),
    children: [/*#__PURE__*/_jsx(MultipleChoiceEditLayout, {
      ref: wrapperEditRef,
      isFocus: isFocus,
      children: isFocus && /*#__PURE__*/_jsx(MultipleChoiceEdit, _objectSpread(_objectSpread({}, props), {}, {
        question: question,
        index: index,
        deleteAnswerStatus: deleteAnswerStatus,
        createAnswerStatus: createAnswerStatus,
        isDisabledInputs: isDisabledInputs //question
        ,
        onDelete: onDelete,
        onUpdate: onUpdate,
        onUpdateType: onUpdateType,
        defaultDescription: defaultDescription //answer
        ,
        onCreateAnswer: onCreateAnswer,
        onResetCreateAnswer: onResetCreateAnswer,
        onUpdateAnswer: onUpdateAnswer,
        onDeleteAnswer: onDeleteAnswer,
        onUpdateCorrectAnswer: onUpdateCorrectAnswer,
        onResetDeleteAnswer: onResetDeleteAnswer
      }))
    }), /*#__PURE__*/_jsx(MultipleChoicePreviewLayout, {
      "data-question-preview": true,
      className: "question-content",
      ref: wrapperPreviewRef,
      isFocus: isFocus,
      children: /*#__PURE__*/_jsx(MultipleChoicePreview, {
        question: question,
        index: index
      })
    })]
  });
};